import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
      $user: {
        unread_notifications: 0,
        sector_id: null,
        district_id: null,
        branch_id: null,
        role: {},
        permissions: [],
        is_email_notify: false,
        is_line_notify: false,
        is_admin: false,
      },
      intended: null,
      need_register_line: false,
      sector_id: null,
      district_id: null,
      branch_id: null,
    },
    mutations: {},
    actions: {},
    modules: {}
});
